package ru.villawonka.app.domain.model

enum class CurrencyDomain {
    USD,
    RUB,
    IDR,
    CNY,
}